<template>
  <div>
    <el-form :rules="rules" :model="loginForm" ref="loginForm" class="login-container" label-position="left" label-width="0px" v-loading="loading">
      <div class="login_title">
        <a href="https://www.hrbox.jp/"><img :src="require('@/assets/LOGO004.jpg')" style="width: 160px; height: 56px;" /></a>
        <!-- <i class="fa fa-globe"></i>
      <el-button class="login_title" @click="jump('/')" type="text"><i>HR&nbsp;{{$t("home.system")}}</i></el-button> -->
      </div>
      <el-form-item prop="username">
        <el-input type="text" v-model="loginForm.username" auto-complete="off" placeholder="ユーザー名" clearable></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="loginForm.password" auto-complete="off" placeholder="パスワード" show-password clearable></el-input>
      </el-form-item>
      <!-- <el-checkbox class="login_remember" v-model="checked" label-position="left">{{$t("login.remember")}}</el-checkbox>
      <br>-->

      <el-form-item style="width: 100%">
        <el-button type="primary" @click.native.prevent="submitClick" style="width: 100%">{{$t("login.button")}}</el-button>
      </el-form-item>

      <el-button class="el-icon-user-solid" type="text" @click="jump('/registerSelect')">アカウントの新規登録</el-button>
      <el-button class="el-icon-question" type="text" @click="jump('/forget')">ユーザID・パスワードを忘れた場合</el-button>

      <el-form-item>
        <el-link type="primary" disabled>English</el-link>&nbsp;&nbsp;&nbsp;&nbsp;
        <el-link type="primary" disabled>日文</el-link>
      </el-form-item>
    </el-form>

    <el-footer>
      <div class="link1">
        <el-link href="https://www.hrbox.jp/" target="_blank">ヘルプ</el-link>
        <el-link href="https://www.hrbox.jp/company.html" target="_blank">会社概要</el-link>
        <el-link href="https://www.hrbox.jp/protocol.html" target="_blank">利用規約</el-link>
        <el-link target="_blank">特定商取引法に基づく表記</el-link>
      </div>
      <div class="link2">
        <el-link href="https://www.hrbox.jp/" target="_blank" :underline="false">© SENSE, Inc.</el-link>
      </div>
    </el-footer>
  </div>
</template>
<script>
import { postRequest } from "../utils/api";
import { isIntersect } from "../utils/utils";
export default {
  data() {
    return {
      rules: {
        username: [
          {
            required: true,
            message: "ユーザー名（半角）を入力してください",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "パスワード（半角）を入力してください",
            trigger: "blur",
          },
        ],
      },
      checked: true,
      loginForm: {
        // username: "sense",
        // password: "aaa666",
      },
      loading: false,
    };
  },
  methods: {
    jump(path) {
      this.$router.push(path);
    },
    clearAllCookie() {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--;)
          document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
      }
    },
    submitClick: function () {
      var _this = this;
      this.loading = true;
      // var LoginUserId = window.localStorage.getItem('LoginUserId');
      // if(LoginUserId > 0){
      //   this.$message.error("現在のブラウザに登録しているユーザーからログアウトしてください。");
      //   this.loading = false;
      // }else {
      postRequest("/login", {
        username: this.loginForm.username,
        password: this.loginForm.password,
      }).then(
        (resp) => {
          _this.loading = false;
          if (resp.status == 200) {
            //成功
            var json = resp.data;
            if (json.status == "success") {
              _this.$i18n.locale = json.locale;
              const roles = json.roles;
              console.log(roles);

              _this.$router.options.routes.map((r) => {
                if (
                  r.name !== "ログイン" &&
                  r.name !== "ホーム" &&
                  r.name !== "会員登録" &&
                  r.name !== "checkCode" &&
                  r.name !== "forger" &&
                  r.name !== "PWReset" &&
                  r.name !== "詳細情報" &&
                  r.name !== "勤怠管理" &&
                  r.name !== "基本台帳" &&
                  r.name !== "社会保険" &&
                  r.name !== "雇用保険" &&
                  // r.name !== "年末調整" &&
                  r.name !== "会員プラン選択" &&
                  r.name !== "News"
                ) {
                  if (
                    r.meta.roles === undefined ||
                    r.meta.roles.length == 0 ||
                    isIntersect(roles, r.meta.roles)
                  ) {
                    r.hidden = false;
                  } else {
                    r.hidden = true;
                  }

                  if (r.children !== undefined && r.children.length > 0) {
                    r.children.map((c) => {
                      if (
                        c.meta.roles === undefined ||
                        c.meta.roles.length == 0 ||
                        isIntersect(roles, c.meta.roles)
                      ) {
                        c.hidden = false;
                      } else {
                        c.hidden = true;
                      }
                    });
                  }
                }
              });
              _this.axios.post("/currentUserId").then((response) => {
                var uid = response.data;
                window.localStorage.setItem('LoginUserId', uid);
                
                _this.$router.push({ path: "/homePage" });
              });


            } else {
              _this.$alert("ユーザー名かパスワードが間違っています", "エラー");
            }
          } else {
            //失败
            _this.$alert("ログインできません!", "エラー");
          }
        },
        (resp) => {
          _this.loading = false;
          _this.$alert("サーバーが見つかりません⊙﹏⊙∥!", "エラー");
        }
      );
    }
  },
  // },

  // mounted: function () {


  // },
};
</script>
<style scoped>
.login-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin-top: 120px;
  margin-bottom: 39px;
  margin-left: auto;
  margin-right: auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}

.login_title {
  color: #4d5357;
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 15px;
}

.login_remember {
  margin: 0px 0px 35px 0px;
  text-align: left;
}

.link1 {
  margin: auto;
}
.link2 {
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue